import React from "react";

import style from "./ButtonCenterBack.module.css";
import xIcon from "src/assets/png/arrow_back_2.png";

const ButtonCenterBack = (props: any) => {
  return (
    <div
      className={style.x}
      style={{
        backgroundImage: `url(${xIcon})`,
        cursor: props?.loading ? "wait" : "pointer",
        pointerEvents: props?.loading ? "none" : "auto",
      }}
      onClick={(e) => {
        props?.onClick();
      }}
    />
  );
};

export default ButtonCenterBack;
